<div [formGroup]="form()">
  <div>
    <label
      class="fw-bold"
      for="dynamic-choices-dropdown"
      translate
      >JuryForm.Field.NumberOfChoices</label
    >

    <app-boostrap-dropdown
      id="dynamic-choices-dropdown"
      [items]="choices"
      [currentIndex]="currentIndex"
      [editable]="!form()?.disabled"
      defaultLabel="Select number of choices"
      styleClass="w-100"
      (selectItem)="onChangeChoice($event)"
    >
    </app-boostrap-dropdown>
  </div>

  <div
    class="mt-3"
    formArrayName="selections"
  >
    @for (control of choicesFormArray.controls; track $index) {
      <div
        class="mb-3"
        [formGroupName]="$index"
      >
        <label
          class="fw-bold"
          [for]="'choice-input-' + $index"
        >
          {{ 'JuryForm.Field.Choice' | translate }} {{ $index + 1 }}
        </label>

        <div>
          <input
            [id]="'choice-input-' + $index"
            formControlName="label"
            class="form-control"
            type="text"
            [placeholder]="
              ('JuryForm.Field.Choice' | translate) + ' ' + ($index + 1)
            "
          />
        </div>

        @if (control.get('label')?.hasError('required')) {
          <div
            class="alert alert-danger"
            translate
          >
            JuryForm.Validation.Required
          </div>
        }
        @if (
          !control.get('label')?.hasError('required') &&
          isDuplicateChoice($index)
        ) {
          <div
            class="alert alert-danger"
            translate
          >
            JuryForm.Validation.DuplicateChoices
          </div>
        }
      </div>
    }
  </div>
</div>
